/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import FileUploaderProvider from 'DesignSystem/FileUploaderProvider/react'
import Modal from './Modal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/Upload/Content",
  restrictions
  
}) {
  return (<React.Fragment
>
<FileUploaderProvider
  viewPath={`${viewPath}/FileUploaderProvider`}
 reset={true}
 restrictions={restrictions}
 dropPasteImportFilesMessage="Drag and drop files here, %{browse} from your computer or import from devices:"
>
{childProps => (
<Modal
{...childProps}
  viewPath={`${viewPath}/Modal`}
/>
)}
</FileUploaderProvider>
{children}
</React.Fragment>)
}